import { Checkbox, Text } from '..';

interface ICheckboxItemProps {
  label: string;
  imageComponent?: React.ReactNode;
  imageAlign?: 'row' | 'column';
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
}

export const CheckboxItem = (props: ICheckboxItemProps) => {
  const { label, imageComponent, imageAlign = 'row', isChecked, onChange } = props;

  return (
    <>
      {imageComponent ? (
        <div
          onClick={() => {
            onChange(isChecked);
          }}
          style={{ cursor: 'pointer', width: 100 }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Checkbox
              checked={isChecked}
              sx={{
                width: 20,
                height: 20,
                marginLeft: 0
              }}
            />
            {imageAlign === 'row' ? <div style={{ marginRight: '8px' }}>{imageComponent}</div> : null}
            <Text variant="body1" style={{ whiteSpace: 'nowrap' }}>
              {label}
            </Text>
          </div>
          {imageAlign !== 'row' ? <div style={{ marginTop: '6px' }}>{imageComponent}</div> : null}
        </div>
      ) : (
        <div
          onClick={() => {
            onChange(isChecked);
          }}
          style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
        >
          <Checkbox
            checked={isChecked}
            onClick={() => {
              onChange(isChecked);
            }}
            sx={{
              width: 20,
              height: 20,
              marginLeft: 0
            }}
          />
          <Text variant="body1">{label}</Text>
        </div>
      )}
    </>
  );
};
